import { createSelector } from 'reselect'

export const getId = (state, props) => props.cardContext.id

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

export default createSelector(
  [
    getId,
    getBoardId,
    getIsTemplate,
  ],
  (
    id,
    boardId,
    isTemplate,
  ) => ({
    id,
    boardId,
    isTemplate,
  })
)
